// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2QiUT","cell":"ColumnAccessor_cell__WwGgK","firstCellAccent":"ColumnAccessor_firstCellAccent__2Zesq"};